import { Env } from '@stencil/core';

export interface Variables {
  StylesheetURL: string;
  SentimentsEndpoint: string;
  QuestionsEndpoint: string;
  QuestionsEndpointNew: string;
  SnowplowContext: string;
  SnowplowRatingEvent: string;
  SnowplowCESRatingEvent: string;
  SnowplowFeedbackEvent: string;
  SnowplowCustomEvent: string;
  SnowplowCustomContext: string;
  BrtSecurityKey: string;
  BrtSecurityAlgorithm: string;
}

export const EnvConfigs: Variables = {
  StylesheetURL: Env.stylesheetURL,
  SentimentsEndpoint: Env.sentimentsEndpoint,
  QuestionsEndpoint: Env.questionsEndpoint,
  QuestionsEndpointNew: Env.questionsEndpointNew,
  SnowplowContext: Env.snowplowContext,
  SnowplowRatingEvent: Env.snowplowRatingEvent,
  SnowplowCESRatingEvent: Env.snowplowRatingEvent,
  SnowplowFeedbackEvent: Env.snowplowFeedbackEvent,
  SnowplowCustomEvent: Env.snowplowCustomEvent,
  SnowplowCustomContext: Env.snowplowCustomContextEvent,
  BrtSecurityKey: Env.brtSecurityKey,
  BrtSecurityAlgorithm: Env.brtSecurityAlgorithm,
};

export const Version = Env.version;
export const BuildNumber = Env.buildNumber;
export const Stage = Env.stage;
